import type { Hex } from 'viem';
import { createClient, http } from 'viem';
import { getCode, getTransactionCount } from 'viem/actions';

import { BASE_RPC_ENDPOINT } from '#src/config.ts';

const EIP_7702_DESIGNATOR = '0xef0100';

let baseClient: ReturnType<typeof buildBaseClient> | undefined;

function buildBaseClient() {
  return createClient({ transport: http(BASE_RPC_ENDPOINT) });
}

function getBaseClient() {
  baseClient ??= buildBaseClient();
  return baseClient;
}

export function isEip7702Delegated(code: Hex | undefined) {
  return !!code && code.toLowerCase().startsWith(EIP_7702_DESIGNATOR);
}

export async function getEip7702Delegation(address: Hex) {
  const code = await getCode(getBaseClient(), { address });
  return { delegated: isEip7702Delegated(code) };
}

export async function getBaseNonce(address: Hex) {
  return getTransactionCount(getBaseClient(), {
    address,
    blockTag: 'latest',
  });
}
